export default [
	{  // 流量统计
		path: 'statistic_flow_list',
		name: 'm_statistic_flow',
		component: () => import('@/pages/data/statistic_flow')
	}, {  // 用户统计
		path: 'statistic_user_list',
		name: 'm_statistic_platform_user',
		component: () => import('@/pages/data/statistic_platform_user')
	},{  // 交易统计
		path: 'statistic_trans_list',
		name: 'm_statistic_trans',
		component: () => import('@/pages/data/statistic_trans')
	}, {  // 商品统计
		path: 'statistic_product_list',
		name: 'm_statistic_product',
		component: () => import('@/pages/data/statistic_product')
	}, {  // 业务员统计
		path: 'statistic_salesman_list',
		name: 'm_statistic_salesman',
		component: () => import('@/pages/data/statistic_salesman')
	}, {  // 商家统计
		path: 'statistic_stationed_list',
		name: 'm_statistic_stationed',
		component: () => import('@/pages/data/statistic_stationed.vue')
	}
];